export const gender_choices = {
  "M": "Male",
  "F": "Female",
  "O": "Other",
  "N": "Prefer Not to Say",
};
export const location_choices = {
  "Kenyenya": "Kenyenya",
  "Kakamega": "Kakamega",
  "Maseno": "Maseno",
  "Eldoret": "Eldoret",
};
export const university_choices = {
  "Kisii University": "Kisii University",
  "Masinde Muliro University": "Masinde Muliro University",
  "Maseno University": "Maseno University",
  "Moi University": "Moi University",
  "University of Eldoret": "University of Eldoret",
};
export const type_of_room_choices = {
  "Single Rooms": "Single Rooms",
  "Double Rooms": "Double Rooms",
  "Bed Sitters": "Bed Sitters",
  "One Bedrooms": "One Bedrooms",
  "Two Bedrooms": "Two Bedrooms",
  "Three Bedrooms": "Three Bedrooms",
};
export const features_choices = {
  "Garbage Collection": "Garbage Collection",
  "Residents Gym": "Residents Gym",
  "QuietStudy Areas": "Quiet Study Areas",
  "Key Card Access": "Key Card Access",
  "Back-up Generator": "Back-up Generator",
  "Pharmacy": "Pharmacy",
  "Bank": "Bank",
  "Fully Furnished Rooms": "Fully Furnished Rooms",
  "High Speed WIFI": "High Speed WIFI",
  "Chillou tLounge": "Chillout Lounge",
  "Constant Water Supply": "Constant Water Supply",
  "CCTV & 24/7 Security": "CCTV & 24/7 Security",
  "Reception Area": "Reception Area",
  "Restaurants": "Restaurants",
  "Pick & Drop Laundry": "Pick & Drop Laundry",
  "Laundry Area": "Laundry Area",
  "Bus Shuttle": "Bus Shuttle",
};

export const check_in = {
  "January": "January",
  "February": "February",
  "March": "March",
  "April": "April",
  "May": "May",
  "June": "June",
  "July": "July",
  "August": "August",
  "September": "September",
  "October": "October",
  "November": "November",
  "December": "December",
};
